import { Icon, Text } from "@growtherapy/sprout-ui";
import { VisitorDrawerButton } from "../../VisitorDrawerButton";
import { VisitorDrawerState, visitorDrawerStateAtom } from "../../state";
import { CTAProps } from "./PreSessionPrompt";
import { useAtom } from "jotai";
import { ComponentProps, useEffect } from "react";
import { faChevronRight } from "@fortawesome/pro-solid-svg-icons";
import { WAITING_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID } from "../../constants";
import {
  CHECK_IN_CTA_BUTTON_TEXT,
  PRE_SESSION_PROMPT_CTA_INTRO_TEXT,
} from "./lang";
import { WaitingRoomState } from "../types";

export function MoodSurveyCta({
  openDrawer,
  state,
  ...otherProps
}: CTAProps & Partial<ComponentProps<typeof VisitorDrawerButton>>) {
  const [drawerState, setDrawerState] = useAtom(visitorDrawerStateAtom);

  useEffect(() => {
    return function closeDrawerOnUmount() {
      if (drawerState !== VisitorDrawerState.MOOD_CHECK_IN_FORM) return;

      setDrawerState(null);
    };
  }, [drawerState, setDrawerState]);

  return (
    <>
      {state === WaitingRoomState.AWAITING_ADMISSION && (
        <Text
          data-testid="pre-session-prompt-mood-survey"
          className="font-medium"
        >
          {PRE_SESSION_PROMPT_CTA_INTRO_TEXT}
        </Text>
      )}

      <VisitorDrawerButton
        {...otherProps}
        closedAriaLabel="Open mood survey"
        openedAriaLabel="Close mood survey"
        drawerId={WAITING_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID}
        forDrawerStates={VisitorDrawerState.MOOD_CHECK_IN_FORM}
        className="flex gap-4 justify-center items-center w-full rebrand:w-component-900"
        onClick={() => openDrawer(VisitorDrawerState.MOOD_CHECK_IN_FORM)}
      >
        <span>{CHECK_IN_CTA_BUTTON_TEXT}</span>
        <Icon aria-hidden icon={faChevronRight} />
      </VisitorDrawerButton>
    </>
  );
}
